import { mobilePatterns } from "../../Constant";
import dayjs from "dayjs";

export const LETTERS_ONLY_REGEX =
  /^[A-Za-z\u0621-\u064A\u06CC\u06A9\u06AF\u0686\u0698\u067E\u0629\u0640\s]+$/u;

// Arabic validation function
export const validateArabicOnly = (value, t) => {
  if (!value) return true; // Let required validation handle empty values

  // Regular expression for Arabic letters, Hamza forms, diacritics, and spaces
  const arabicPattern =
    /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\s]+$/;

  if (!arabicPattern.test(value)) {
    return t("ARABIC_ONLY_VALIDATION");
  }

  return true;
};

// Arabic and numbers validation function
export const validateArabicAndNumbersOnly = (value, t) => {
  if (!value) return true; // Let required validation handle empty values

  // Arabic letters (same ranges as validateArabicOnly) + digits + spaces
  const arabicAndNumbersPattern =
    /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF0-9\s]+$/;

  if (!arabicAndNumbersPattern.test(value)) {
    return t("ARABIC_AND_NUMBERS_ONLY_VALIDATION");
  }

  return true;
};

// English and numbers validation function
export const validateEnglishAndNumbersOnly = (value, t) => {
  if (!value) return true;

  const englishAndNumbersPattern = /^[a-zA-Z0-9\s\-']+$/;

  if (!englishAndNumbersPattern.test(value)) {
    return t("ENGLISH_AND_NUMBERS_ONLY_VALIDATION");
  }

  return true;
};

// English validation function
export const validateEnglishOnly = (value, t) => {
  if (!value) return true; // Let required validation handle empty values

  // Regular expression for English letters, spaces, hyphens, and apostrophes
  const englishPattern = /^[a-zA-Z\s\-']+$/;

  if (!englishPattern.test(value)) {
    return t("ENGLISH_ONLY_VALIDATION");
  }

  return true;
};

// Saudi National ID validation function
export const validateSaudiNationalId = (value, t) => {
  if (value == null || value === "") return true; // Let required validation handle empty values

  const str = String(value);

  // Check if first digit is 1 (citizens) or 2 (residents)
  const firstDigit = str.charAt(0);

  if (firstDigit !== "1" && firstDigit !== "2") {
    return t("NATIONAL_ID_START_VALIDATION");
  }

  // Check if it contains exactly 10 digits
  const digitPattern = /^\d{10}$/;

  if (!digitPattern.test(str)) {
    return t("NATIONAL_ID_LENGTH_VALIDATION");
  }

  return true;
};

// Mobile validation function based on country code
export const validateMobile = (value, formValues, t) => {
  if (!value) return true; // Let required validation handle empty values

  const countryCode = formValues.phoneCountryCode;

  // Remove any non-digit characters from the mobile number
  const cleanMobile = value.replace(/\D/g, "");

  const pattern = mobilePatterns[countryCode];

  if (!pattern) {
    // If no specific pattern found, validate as general mobile number (7-15 digits)
    const generalPattern = /^[0-9]{7,15}$/;
    if (!generalPattern.test(cleanMobile)) {
      return t("MOBILE_INVALID");
    }
    return true;
  }

  if (!pattern.test(cleanMobile)) {
    return t("MOBILE_INVALID");
  }

  return true;
};

export const saudiMobileRules = (t) => ({
  minLength: {
    value: 10,
    message: t("MOBILE_LENGTH_VALIDATION"),
  },
  maxLength: {
    value: 10,
    message: t("MOBILE_LENGTH_VALIDATION"),
  },
  pattern: {
    value: /^05[0-9]{8}$/,
    message: t("MOBILE_START_VALIDATION"),
  },
});

export const numbersOnlyRules = (t) => ({
  pattern: {
    value: /^[0-9]+$/,
    message: t("NUMBERS_ONLY_VALIDATION"),
  },
});

export const futureDateValidation = (t) => ({
  validate: (value) => {
    if (!value) return true;
    const now = dayjs();
    if (dayjs(value).isBefore(now, "minute")) {
      return t("FLIGHTS_MODAL_FUTURE_DATE_VALIDATION");
    }
    return true;
  },
});

export const maxLengthValidation = (t, maxLength) => ({
  maxLength: {
    value: maxLength,
    message: t("MAX_LENGTH", {
      max: maxLength,
    }),
  },
});
export const validateImage = (file) => {
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isLt2M) return true;

  return false; // Still prevent auto-upload
};
